$().ready(function () {
// Floating Label inputs
const textfieldFloatingLabelElements = document.querySelectorAll('.js-form-textfield.form-textfield-floating-label');
Array.prototype.forEach.call(textfieldFloatingLabelElements, (el) => {
  const inputEl = el.querySelector('.form-textfield-input');
  if (inputEl.value === null || inputEl.value === '' ) {
    el.classList.add('empty');
  }
  inputEl.addEventListener('focus', () => {
    el.classList.remove('empty');
  });
  inputEl.addEventListener('keypress', () => {
    el.classList.remove('empty');
  });
  inputEl.addEventListener('blur', () => {
    if (inputEl.value === null || inputEl.value === '') {
      el.classList.add('empty');
    }
  });

});

// Floating Label select
const selectFloatingLabelElements = document.querySelectorAll('.js-form-select.form-select-floating-label');
Array.prototype.forEach.call(selectFloatingLabelElements, (el) => {
  const selectEl = el.querySelector('.form-select-input');
  const childOptions = selectEl.querySelector('option');
  let selectedOption = selectEl.options[selectEl.selectedIndex];

  if (selectEl.value === null) {
    el.classList.add('empty');
  }
  if (childOptions.length === null || childOptions.length === 0 || selectedOption && selectedOption.text === '') {
    el.classList.add('empty');
  }
  selectEl.addEventListener('focus', () => {
    el.classList.remove('empty');
  });
  selectEl.addEventListener('keypress', () => {
    el.classList.remove('empty');
  });
  selectEl.addEventListener('blur', () => {
    if (childOptions.length === null || childOptions.length === 0) {
      el.classList.add('empty');
    }

  });
  selectEl.addEventListener('change', () => {
    if ((childOptions.length === null || childOptions.length === 0)) {
      el.classList.add('empty');
    }
    selectedOption = selectEl.options[selectEl.selectedIndex];
    if (selectEl.value === null || selectedOption && selectedOption.text === '') {
      el.classList.add('empty');
    } else {
      el.classList.remove('empty');
    }
  });
});

// Floating Label textarea
const textareaFloatingLabelElements = document.querySelectorAll('.js-form-textarea.form-textarea-floating-label');
Array.prototype.forEach.call(textareaFloatingLabelElements, (el) => {
  const textareaEl = el.querySelector('.form-textarea-input');
  if (textareaEl !== null) {
    if (textareaEl.value === null || textareaEl.value === '') {
      el.classList.add('empty');
    }
    textareaEl.addEventListener('focus', () => {
      el.classList.remove('empty');
    });
    textareaEl.addEventListener('keypress', () => {
      el.classList.remove('empty');
    });
    textareaEl.addEventListener('blur', () => {
      if (textareaEl.value === null || textareaEl.value === '') {
        el.classList.add('empty');
      }
    });
  }
});

const textareaFloatingLabelElementscustom = document.querySelectorAll('.js-form-textarea.form-textarea-floating-label');
Array.prototype.forEach.call(textareaFloatingLabelElementscustom, (el) => {
  const textareaElCustom = el.querySelector('.form-control-rsl');
  if (textareaElCustom !== null) {
    if (textareaElCustom.value === null || textareaElCustom.value === '') {
      el.classList.add('empty');
    }
    textareaElCustom.addEventListener('focus', () => {
      el.classList.remove('empty');
    });
    textareaElCustom.addEventListener('keypress', () => {
      el.classList.remove('empty');
    });
    textareaElCustom.addEventListener('blur', () => {
      if (textareaElCustom.value === null || textareaElCustom.value === '') {
        el.classList.add('empty');
      }
    });
  }
});


const singleLineDateInputCustom = document.querySelectorAll('.js-single-date-input');
Array.prototype.forEach.call(singleLineDateInputCustom, (el) => {
  el.addEventListener('input', function (e) {
    this.type = 'text';
    var input = this.value;
    if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
    var values = input.split('/').map(function (v) {
      return v.replace(/\D/g, '')
    });
    if (values[0]) values[0] = checkValue(values[0], 31);
    if (values[1]) values[1] = checkValue(values[1], 12);

    var output = values.map(function (v, i) {
      return v.length == 2 && i < 2 ? v + ' / ' : v;
    });
    this.value = output.join('').substr(0, 14);
  });

  el.addEventListener('blur', function (e) {
    this.type = 'text';
    var input = this.value;
    var values = input.split('/').map(function (v, i) {
      return v.replace(/\D/g, '')
    });
    var output = '';

    if (values.length == 3) {
      var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
      var month = parseInt(values[1]) - 1;
      var day = parseInt(values[0]);
      var d = new Date(year, month, day);
      if (!isNaN(d)) {
        var dates = [d.getDate(), d.getMonth() + 1, d.getFullYear()];
        output = dates.map(function (v) {
          v = v.toString();
          return v.length == 1 ? '0' + v : v;
        }).join(' / ');
      };
    };
    this.value = output;
  });
});

// helper for Single Line Date Input
function checkValue(str, max) {
  if (str.charAt(0) !== '0' || str == '00') {
    var num = parseInt(str);
    if (isNaN(num) || num <= 0 || num > max) num = 1;
    str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
  };
  return str;
};
});